export enum CorrectionStatus {
  PENDING = 'PENDING',

  SUCCESS = 'SUCCESS',

  REJECT = 'REJECT',
}
